/* Fardo.cl - Tier price cards
   Markup y estilos: snippets/tier-price-cards.liquid

   HOVER  = vista previa (precio del titulo, badge, color y cantidad).
            Al salir vuelve al valor comprometido.
   CLICK  = compromete el tier (la cantidad queda fija).
*/
(function () {
  var applying = false;
  var applyTimer = null;
  var previewing = false;

  function holdApplying(ms) {
    applying = true;
    clearTimeout(applyTimer);
    applyTimer = setTimeout(function () { applying = false; }, ms || 150);
  }

  function findContainer(el) {
    return el.closest ? el.closest('[data-tier-cards]') : null;
  }
  function getForm(container) {
    return container.closest('product-form');
  }
  function getQtyInput(container) {
    var form = getForm(container);
    return form ? form.querySelector('input[name="quantity"]') : null;
  }
  function cardForQty(container, qty) {
    return container.querySelector('[data-tier][data-qty="' + qty + '"]');
  }
  function setTone(container, tone) {
    var form = getForm(container);
    if (!form) return;
    if (tone) form.setAttribute('data-tier-tone', tone);
    else form.removeAttribute('data-tier-tone');
  }

  /* Escribe la cantidad sin que se dispare la logica de seleccion. */
  function setQtyInput(container, qty) {
    var input = getQtyInput(container);
    if (!input) return;
    if (String(input.value) === String(qty)) return;
    previewing = true;
    input.value = qty;
    try {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } finally {
      previewing = false;
    }
  }

  function getData(container) {
    if (container.__tierData !== undefined) return container.__tierData;
    var tag = container.querySelector('script[data-tier-prices]');
    try {
      container.__tierData = tag ? JSON.parse(tag.textContent) : null;
    } catch (err) {
      container.__tierData = null;
    }
    return container.__tierData;
  }
  function getVariantData(container) {
    var data = getData(container);
    if (!data) return null;
    var form = getForm(container);
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var vid = idInput ? String(idInput.value) : null;
    if (vid && data[vid]) return data[vid];
    var keys = Object.keys(data);
    return keys.length ? data[keys[0]] : null;
  }
  function getPriceEls(container) {
    var scope = container.closest('section') || document;
    var els = [];
    var main = scope.querySelector('.product--price-container') || scope.querySelector('[id^="price-"]');
    if (!main) return els;
    els.push(main);
    var idNode = main.id ? main : main.querySelector('[id^="price-"]');
    if (idNode && idNode.id) {
      var sticky = document.getElementById(idNode.id + '--sticky');
      if (sticky) els.push(sticky);
    }
    return els;
  }
  function getAmountNode(priceEl) {
    var ins = priceEl.querySelector('ins');
    if (ins) return ins.querySelector('.amount') || ins;
    var amounts = priceEl.querySelectorAll('.amount');
    for (var i = 0; i < amounts.length; i++) {
      if (!amounts[i].classList.contains('discounted')) return amounts[i];
    }
    return null;
  }

  function applyStock(container, vdata) {
    if (!vdata) return true;
    var anyDiscount = false;
    container.querySelectorAll('[data-tier]').forEach(function (card) {
      var t = vdata.tiers[card.getAttribute('data-qty')];
      var ok = !!(t && t.ok);
      card.hidden = !ok;
      if (ok && t.discount > 0) anyDiscount = true;
    });
    container.hidden = !anyDiscount;
    return anyDiscount;
  }

  function paintCards(container, vdata) {
    if (!vdata) return;
    container.querySelectorAll('[data-tier]').forEach(function (card) {
      var t = vdata.tiers[card.getAttribute('data-qty')];
      if (!t) return;
      var priceSpan = card.querySelector('[data-tier-unit]');
      if (priceSpan) priceSpan.innerHTML = t.money + ' <small>c/u</small>';
      var saveSpan = card.querySelector('[data-tier-save]');
      if (saveSpan && t.discount > 0) saveSpan.textContent = 'Ahorras ' + t.save;
    });
  }

  function paintOnePrice(priceEl, t, qty, vdata) {
    var amount = getAmountNode(priceEl);
    if (!amount) return;
    amount.textContent = t.money;

    var anchor = amount.closest('ins') || amount;
    var suffix = priceEl.querySelector('.fardo-price-unit');
    if (parseInt(qty, 10) > 1) {
      if (!suffix) {
        suffix = document.createElement('span');
        suffix.className = 'fardo-price-unit';
        if (anchor.parentNode) anchor.parentNode.insertBefore(suffix, anchor.nextSibling);
      }
      suffix.textContent = 'c/u';
    } else if (suffix && suffix.parentNode) {
      suffix.parentNode.removeChild(suffix);
    }

    var badge = priceEl.querySelector('.badge.onsale') || priceEl.querySelector('.badge');
    if (badge && vdata.compare_at > 0) {
      var pct = Math.round(((vdata.compare_at - t.price) / vdata.compare_at) * 100);
      badge.textContent = pct + '% DCTO';
    }
  }

  function paintTitlePrice(container, qty) {
    var vdata = getVariantData(container);
    if (!vdata) return;
    var t = vdata.tiers[String(qty)];
    if (!t) return;
    getPriceEls(container).forEach(function (el) {
      paintOnePrice(el, t, qty, vdata);
    });
  }

  function selectedQty(container) {
    return container.getAttribute('data-tier-selected') || '1';
  }

  function restTone(container) {
    var qty = selectedQty(container);
    var card = cardForQty(container, qty);
    var disc = card ? parseInt(card.getAttribute('data-discount'), 10) : 0;
    setTone(container, (card && disc > 0) ? card.getAttribute('data-tone') : null);
  }

  /* Vista previa al pasar el mouse. Guarda la cantidad comprometida
     la primera vez que se entra al grupo, para poder devolverla al salir. */
  function previewTier(container, qty) {
    holdApplying(250);
    var input = getQtyInput(container);
    if (input && container.__committedQty == null) {
      container.__committedQty = input.value;
    }
    paintTitlePrice(container, qty);
    setQtyInput(container, qty);
    var card = cardForQty(container, qty);
    setTone(container, card ? card.getAttribute('data-tone') : null);
  }

  function endPreview(container) {
    holdApplying(250);
    if (container.__committedQty != null) {
      setQtyInput(container, container.__committedQty);
      container.__committedQty = null;
    }
    paintTitlePrice(container, selectedQty(container));
    restTone(container);
  }

  function refresh(container) {
    holdApplying(150);
    var vdata = getVariantData(container);
    var qty = selectedQty(container);
    var t = vdata ? vdata.tiers[String(qty)] : null;
    if (!t || !t.ok) {
      qty = '1';
      container.setAttribute('data-tier-selected', '1');
    }
    paintCards(container, vdata);
    applyStock(container, vdata);
    paintTitlePrice(container, qty);
    restTone(container);
  }

  function clearSelection(container) {
    container.querySelectorAll('[data-tier]').forEach(function (c) {
      c.classList.remove('is-selected');
      c.setAttribute('aria-pressed', 'false');
    });
  }
  function markSelected(card) {
    card.classList.add('is-selected');
    card.setAttribute('aria-pressed', 'true');
  }
  function selectCardForQty(container, qty) {
    var cards = Array.prototype.slice.call(container.querySelectorAll('[data-tier]:not([hidden])'));
    var best = null;
    cards.forEach(function (c) {
      var threshold = parseInt(c.getAttribute('data-qty'), 10);
      if (!isNaN(threshold) && qty >= threshold && (best === null || threshold > best.threshold)) {
        best = { el: c, threshold: threshold };
      }
    });
    clearSelection(container);
    if (best) {
      markSelected(best.el);
      container.setAttribute('data-tier-selected', String(best.threshold));
      refresh(container);
    }
  }

  function watch(container) {
    getPriceEls(container).forEach(function (el) {
      var target = el.parentNode || el;
      if (target.__tierWatched) return;
      target.__tierWatched = true;
      new MutationObserver(function () {
        if (applying) return;
        clearTimeout(container.__tierTimer);
        container.__tierTimer = setTimeout(function () { refresh(container); }, 80);
      }).observe(target, { childList: true, subtree: true, characterData: true });
    });
  }

  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('[data-tier]');
    if (!card || card.hidden) return;
    var container = findContainer(card);
    if (!container) return;
    previewTier(container, card.getAttribute('data-qty'));
  });

  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest && e.target.closest('[data-tier]');
    if (!card) return;
    var container = findContainer(card);
    if (!container) return;
    var to = e.relatedTarget;
    if (to && to.closest && to.closest('[data-tier]')) return;
    endPreview(container);
  });

  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-tier]');
    if (!card || card.hidden) return;
    var container = findContainer(card);
    if (!container) return;
    clearSelection(container);
    markSelected(card);
    var qty = card.getAttribute('data-qty');
    container.setAttribute('data-tier-selected', qty);
    container.__committedQty = null;
    var input = getQtyInput(container);
    if (input) {
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    refresh(container);
  });

  function onQtyChange(e) {
    if (previewing) return;
    var input = e.target;
    if (!input || !input.matches) return;
    if (input.matches('input[name="quantity"]')) {
      var form = input.closest('product-form');
      if (!form) return;
      var container = form.querySelector('[data-tier-cards]');
      if (!container) return;
      container.__committedQty = null;
      selectCardForQty(container, parseInt(input.value, 10) || 0);
      return;
    }
    var host = input.closest('product-form');
    if (!host) return;
    var c2 = host.querySelector('[data-tier-cards]');
    if (!c2) return;
    c2.__tierData = undefined;
    setTimeout(function () { watch(c2); refresh(c2); }, 350);
    setTimeout(function () { watch(c2); refresh(c2); }, 900);
  }
  document.addEventListener('input', onQtyChange);
  document.addEventListener('change', onQtyChange);

  function init() {
    document.querySelectorAll('[data-tier-cards]').forEach(function (container) {
      if (!container.getAttribute('data-tier-selected')) {
        container.setAttribute('data-tier-selected', '1');
      }
      watch(container);
      refresh(container);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 1200);
})();

/* Fardo.cl - Correccion "Agregar al carro" con la app de descuentos por volumen.
   La app (g-volume-discounts / mpb) intercepta fetch y XHR hacia /cart/add y
   reemplaza la cantidad por la de su selector oculto (3 unidades por defecto),
   ignorando la cantidad elegida en las tarjetas o en el selector.
   Aqui enviamos /cart/add con el fetch nativo del navegador: se agrega la cantidad
   exacta elegida y el descuento se mantiene, porque el formulario ya lleva
   properties[__mpb_offer_id] y la app calcula el % segun la cantidad del carro. */
(function () {
  var nativeFetch = null;
  function getNative() {
    if (nativeFetch) return nativeFetch;
    try {
      var f = document.createElement('iframe');
      f.style.display = 'none';
      f.setAttribute('aria-hidden', 'true');
      f.tabIndex = -1;
      f.title = 'fardo-cart-helper';
      (document.body || document.documentElement).appendChild(f);
      nativeFetch = f.contentWindow.fetch;
    } catch (e) { nativeFetch = null; }
    return nativeFetch;
  }
  function isCartAdd(input) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    return /\/cart\/add(\.js)?(\?|#|$)/.test(String(u));
  }
  function install() {
    var cur = window.fetch;
    if (!cur || cur.__fardoAddFix) return;
    var nf = getNative();
    if (!nf) return;
    var wrapped = function (input, init) {
      if (isCartAdd(input)) return nf.call(window, input, init);
      return cur.apply(this, arguments);
    };
    wrapped.__fardoAddFix = true;
    window.fetch = wrapped;
  }
  function boot() { install(); }
  if (document.body) boot(); else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', function () { install(); setTimeout(install, 1500); setTimeout(install, 4000); });
  /* Justo antes de agregar al carro nos aseguramos de quedar por fuera de la app. */
  document.addEventListener('submit', install, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('product-form, form[action*="/cart/add"], [data-fardo-buy-now], .fardo-buy-now')) install();
  }, true);
})();
